/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetSkillsResponse
 */
export interface GetSkillsResponse {
    /**
     * 
     * @type {Array<Skill>}
     * @memberof GetSkillsResponse
     */
    topSkills: Array<Skill>;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof GetSkillsResponse
     */
    selectedSkills: Array<Skill>;
}

/**
 * Check if a given object implements the GetSkillsResponse interface.
 */
export function instanceOfGetSkillsResponse(value: object): value is GetSkillsResponse {
    if (!('topSkills' in value) || value['topSkills'] === undefined) return false;
    if (!('selectedSkills' in value) || value['selectedSkills'] === undefined) return false;
    return true;
}

export function GetSkillsResponseFromJSON(json: any): GetSkillsResponse {
    return GetSkillsResponseFromJSONTyped(json, false);
}

export function GetSkillsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSkillsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'topSkills': ((json['topSkills'] as Array<any>).map(SkillFromJSON)),
        'selectedSkills': ((json['selectedSkills'] as Array<any>).map(SkillFromJSON)),
    };
}

export function GetSkillsResponseToJSON(value?: GetSkillsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'topSkills': ((value['topSkills'] as Array<any>).map((v) => SkillToJSON(v))),
        'selectedSkills': ((value['selectedSkills'] as Array<any>).map((v) => SkillToJSON(v))),
    };
}

